import { TIMEZONE_DISPLAY_MAP } from '../../../lib/timezoneUtils';

const commonZones = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Phoenix',
  'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu', 'UTC',
];
const supportedValuesOf = (Intl as typeof Intl & {
  supportedValuesOf?: (key: 'timeZone') => string[];
}).supportedValuesOf;

export function timeZoneLabel(zone: string): string {
  const name = zone === 'America/Phoenix' ? 'Arizona (no daylight saving)' : TIMEZONE_DISPLAY_MAP[zone];
  return name ? `${name} — ${zone.replace(/_/g, ' ')}` : zone.replace(/_/g, ' ');
}

export const CONTACT_TIME_ZONES = [...new Set([...commonZones, ...(supportedValuesOf?.('timeZone') ?? [])])]
  .map(value => ({ value, label: timeZoneLabel(value) }));

export function contactLocalTime(zone: string, now: number): string {
  if (!zone) return '';
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: zone, weekday: 'short', hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
    }).format(now);
  } catch {
    return '';
  }
}
